import { AxiosInstance } from 'axios';
import { Subscription } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'subscription';

export class SubscriptionApi {
  private apiInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getUserSubscriptions(userId: string): Promise<Array<Subscription>> {
    await simulate();
    const response = await this.apiInstance.get(`/${userId}`);

    return response.data;
  }

  async getIntent(priceId: string): Promise<string> {    
    await simulate();

    const response = await this.apiInstance.post('/intent', { priceId });

    return response.data;
  }

  async cancel(subscriptionId: string): Promise<void> {    
    await simulate();

    const response = await this.apiInstance.post('/cancel', { subscriptionId });

    return response.data;
  }
}
